/* eslint-disable no-bitwise */
import { getWindowAccountConfig } from '../../hooks/useAccountConfig';
import EmburseProfessionalLogoImage from '../../assets/images/emburse-professional-logo-300.svg';
const accountConfig = getWindowAccountConfig();
// keycode mappings
var keyCodes;
(function (keyCodes) {
    keyCodes[keyCodes["enter"] = 13] = "enter";
    keyCodes[keyCodes["tab"] = 9] = "tab";
    keyCodes[keyCodes["delete"] = 46] = "delete";
    keyCodes[keyCodes["esc"] = 27] = "esc";
    keyCodes[keyCodes["space"] = 32] = "space";
    keyCodes[keyCodes["up"] = 38] = "up";
    keyCodes[keyCodes["down"] = 40] = "down";
    keyCodes[keyCodes["left"] = 37] = "left";
    keyCodes[keyCodes["right"] = 39] = "right";
    keyCodes[keyCodes["end"] = 35] = "end";
    keyCodes[keyCodes["home"] = 36] = "home";
    keyCodes[keyCodes["del"] = 46] = "del";
    keyCodes[keyCodes["backspace"] = 8] = "backspace";
    keyCodes[keyCodes["insert"] = 45] = "insert";
    keyCodes[keyCodes["pageup"] = 33] = "pageup";
    keyCodes[keyCodes["pagedown"] = 34] = "pagedown";
})(keyCodes || (keyCodes = {}));
const deepClone = (src) => ({
    ...src
});
const isEqualObject = (src, target) => JSON.stringify(src) === JSON.stringify(target);
const Enum = (arr) => {
    const enumObj = {};
    arr.forEach((key, i) => {
        enumObj[(enumObj[key] = i + 1)] = key;
    });
    return Object.freeze(enumObj);
};
const onDocReady = (fn) => {
    // see if DOM is already available
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        // call on next available tick
        // eslint-disable-next-line @typescript-eslint/no-implied-eval
        setTimeout(fn, 1);
    }
    else {
        document.addEventListener('DOMContentLoaded', fn);
    }
};
const getCookie = (cname) => {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};
const setCookie = (cname, cvalue, exdays = 3000) => {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue}; ${expires}; secure`;
};
/**
 * generates a quick non-secure hash
 * @param {string} string the string from which to generate a hash code
 * @returns {string}
 */
const hashCode = (string) => {
    let hash = 0;
    let i;
    let chr;
    for (i = 0; i < string.length; i++) {
        chr = string.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash.toString();
};
/**
 * reads the data attribute "data-language" from the html element, which is set in the master page
 * @returns {string}
 */
const getLanguageId = () => {
    const el = document.documentElement;
    // attribute set in master page code behind
    return el.getAttribute('data-language');
};
/**
 * Looks for class "is-english" on the html element which is set in the master page
 * @returns {boolean}
 */
const isEnglish = () => document.documentElement.classList.contains('is-english');
/**
 * Looks if the user is viewing Certify through a mobile device and determines which function
 * to use since certify mobile cannot open a new tab in the cordova inappbrowser
 */
const openInNewTab = (url) => {
    if (accountConfig.IsCertifyMobile) {
        window.location.assign(url);
        return;
    }
    window.open(url);
};
/**
 * Looks to see if the user is logged in
 * @returns {boolean}
 */
const isUserLoggedIn = () => !!accountConfig?.Emp?.PK;
const getQueryStringParam = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop)
});
// Can use for Random DataGrid id's
const generateRandomGUID = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r && 0x3) | 0x8;
    return v.toString(16).toLowerCase();
});
const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
});
class PollingTimeoutException extends Error {
    constructor() {
        super();
        this.name = 'PollingTimeoutException';
    }
}
const isEmburseProfessional = () => {
    const isLocalhost = window.location.hostname === 'localhost';
    return isLocalhost || document?.documentElement.classList.contains('is-emburse-professional');
};
const { isIE } = window;
const getLogoPropValue = () => {
    if (isIE) {
        return '';
    }
    return isEmburseProfessional() ? EmburseProfessionalLogoImage : 'CertifyEmburse';
};
export { keyCodes, deepClone, isEqualObject, Enum, onDocReady, getCookie, setCookie, hashCode, getLanguageId, isEnglish, openInNewTab, isUserLoggedIn, getQueryStringParam, generateRandomGUID, toBase64, PollingTimeoutException, isEmburseProfessional, getLogoPropValue };
